@use "@css/variables";


.about{

  background-color: white;
  border-radius: var(--border-radius);
  padding: 30px;

}


@media only screen and (min-width: variables.$md-breakpoint) {
  .about{
    padding: 60px;
  }
}
